module.exports = __webpack_public_path__ + "static/quasit-0bc636ddb0ab2607ea6306663f510cd4.jpg";